module.exports = __webpack_public_path__ + "static/media/practice-black.7cb0c02a.svg";